/*!
 * Created by netlogix GmbH & Co. KG.
 *
 * @copyright netlogix GmbH & Co. KG
 */

import * as ReminderActions from '@reminders/store/reminder.actions';
import { initialState, RemindersState } from '@reminders/store/reminders.state';

export function remindersReducer(state = initialState, action: ReminderActions.ReminderActions): RemindersState {
  switch (action.type) {
    case ReminderActions.INIT:
    case ReminderActions.LOAD_MY_REMINDERS_SUCCESS:
      return {
        ...state,
        myReminders: action.myReminders
      };
    case ReminderActions.SET_REMINDER_TIMERS:
      return {
        ...state,
        reminderTimerIds: action.timerIds
      };
    case ReminderActions.SUSPEND_REMINDER:
      return {
        ...state,
        suspendedReminderIds: [...state.suspendedReminderIds, action.reminderId]
      };
    case ReminderActions.RESUME_REMINDER:
      return {
        ...state,
        suspendedReminderIds: state.suspendedReminderIds.filter((id) => id !== action.reminderId)
      };
    default:
      return state;
  }
}
